import React from 'react';
import {Card, CardActions, CardHeader, CardTitle, CardText} from 'material-ui/Card';
import Paper from 'material-ui/Paper';
import { connect } from 'react-redux'
import { resourceApi } from '../utils/fetchUtil';
import { getDirections, openMap } from '../actions/shopActions';
import FlatButton from 'material-ui/FlatButton';
import ActionMap from 'material-ui/svg-icons/maps/place';
import ActionClose from 'material-ui/svg-icons/navigation/close';
import StarRating from 'material-ui/svg-icons/toggle/star';
import ActionDirections from 'material-ui/svg-icons/maps/directions';
import InfoOutline from 'material-ui/svg-icons/action/info-outline';
import Dialog from 'material-ui/Dialog';
import {GridList, GridTile} from 'material-ui/GridList';
import Divider from 'material-ui/Divider';
import HospitalRating from '../Components/HospitalRating';
import ComplicationRating from '../Components/ComplicationRating';
import {logDirectionsClick, logDocDetailsClick, logQualityClick, logProviderView } from '../actions/logActions';

class ProviderCard extends React.Component {
     constructor(props) {
        super(props);
        this.state = {  
            openMap: false,
            openRatings: false,
            openExplain: false,
            fetching: true,
            markers: [],
            explanation: null,
            facilityRatings: [],
            complicationRatings: [],
            providerDetails: null,
            providers: [],
            provider: null
        }

        this.getDirections = this.getDirections.bind(this);
    };


    componentDidMount(){
        this.loadProvider(this.props.providerId);
    }

    handleOpenMap = (a) => {

        var address = a.Address1.replace(/ /g, "+");
        address += "+";
        address += a.City;
        address += "+";
        address += a.State;
        address += "+";
        address += a.ZipCode;
        
        openMap(address);
        
        this.props.logDirectionsClick(this.state.provider.ProviderID, "Map");
    };

    getDirections(a) {
        
        var address = a.Address1.replace(/ /g, "+");
        address += "+";
        address += a.City;
        address += "+";
        address += a.State;
        address += "+";
        address += a.ZipCode || '';

        var m = this.props.member;

        var memberaddr = m.Address1.replace(/ /g, "+");
        memberaddr += "+";
        memberaddr += m.City;
        memberaddr += "+";
        memberaddr += m.State;
        memberaddr += "+";
        memberaddr += m.ZipCode || '';
        
        getDirections(address , memberaddr);

        this.props.logDirectionsClick(this.state.provider.ProviderID, "Directions");
    }

    handleOpenRatings = () => {
        this.props.logQualityClick(this.state.provider.ProviderID);
        this.setState({openRatings: true});
    };

    handleOpenExplain = () => {
        this.setState({openExplain: true});
    };

    handleClose = () => {
         this.setState({openMap: false, openRatings: false, openExplain: false});
    };

    loadDocDetails() {

        var self = this;

        //this.props.logDocDetailsClick(this.state.provider.ProviderID);

        let config = {
            method: 'get',
            url: `provider/${this.state.provider.NPI}/docdetail`
        };

        resourceApi(config)
            .then(function (response) {
                console.log(response);
                
                self.setState({ providerDetails: response.data });

                // self.setState({ markers : [{
                //         position: { lat: response.data.Latitude, lng: response.data.Longitude}
                //     }]
                // });

                // going to make this one call now. 
                //self.loadDocDetails();

                self.setState({fetchingProvider: false});
                //self.setState({ message: response.data.message });
            })
            .catch(function (error) {
                console.log(error);
                self.setState({fetchingProvider: false});
            });
    }

    loadFacilityInfo() {
        var self = this;

        let config = {
            method: 'get',
            url: `facility/${this.state.provider.ProviderID}/complicationsAndRatings`
        };

        resourceApi(config)
        .then(function (response) {
            console.log(response);
            
            self.setState({ facilityRatings: response.data.Ratings });
            self.setState({ complicationRatings: response.data.Complications });
        })
        .catch(function (error) {
            console.log(error);
        });

    }

    loadProviders() {

      var self = this;

      this.setState({fetching: true});

        let config = {
            method: 'get',
            url: `facility/${this.props.params.fid}/providers`
        };

        resourceApi(config)
        .then(function (response) {
            console.log(response);
            
            self.setState({ providers: response.data });
        
            self.setState({fetching: false});
        })
        .catch(function (error) {
            console.log(error);
            self.setState({fetching: false});
        });
    }

    loadProvider(providerId) {

    
        var self = this;
  
        this.setState({fetching: true});
  
          let config = {
              method: 'get',
              url: `provider/${providerId}`
          };
  
          resourceApi(config) 
          .then(function (response) {
              console.log(response);
              
              self.setState({ provider: response.data });
  
              self.props.logProviderView({
                ClientUserID: self.props.member.ClientUserID,
                ProviderID: providerId,
                ShoppableCPTCodeID: self.props.sctp,
                TotalCost: self.props.cost
              });
                  
              self.setState({ markers : [{
                      position: { lat: response.data.Latitude, lng: response.data.Longitude}
                  }]
              });

                if(response.data.IsFacility) {
                    self.loadFacilityInfo();
                }
                else {
                    self.loadDocDetails();
                }
  
              self.setState({ view: "provider", cost: self.props.params.cost });
              self.setState({fetching: false});
  
              
          })
          .catch(function (error) {
              console.log(error);
              self.setState({fetching: false});
          });
      }

    render() {


        var dasFacilityRatings = this.state.facilityRatings.map((rating, index) => 
            <HospitalRating key={index} rating={rating} />
        );

        var dasComplicationsRatings = this.state.complicationRatings.map((rating, index) => 
            <ComplicationRating key={index} rating={rating} />
        );
            

        const actions = [
            <FlatButton
                label="Close"
                labelPosition="after"
                icon={ <ActionClose />}
                primary={true}
                onClick={this.handleClose}
            />
        ];

        return (
            <div>
                {this.state.provider && (
                    <div>
                        <Paper zDepth={1} >
                   
                            {(!this.state.provider.IsFacility) && (
                                <div>
                                    <div className="container">
                                        <h5>{this.state.provider.ProviderAlias || this.state.provider.FirstName + " " + this.state.provider.LastName + ((this.state.provider.CredentialText) ? ", " + this.state.provider.CredentialText : "") }</h5>
                                    </div>
                                    {this.props.cost && (
                                        <div>
                                            <Divider />
                                            <div className="container centered vAlignCenter" >
                                                <h1>{(this.props.cost) ? "$" + Math.round(this.props.cost) : ""}</h1>
                                                {(this.props.cost > 0) && (
                                                    <p>Estimate</p>
                                                )}
                                                <FlatButton label="Explain" icon={<InfoOutline />}  labelPosition="after" onClick={this.handleOpenExplain} primary={true} />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {(this.state.provider.IsFacility) && (
                                <div>
                                    <div className="container">
                                        <h5>{this.state.provider.ProviderAlias || this.state.provider.OrganizationName}</h5>
                                    </div>
                                    <Divider />

                                    <GridList cellHeight={140} >
                                    {this.props.cost && (
                                       
                                            
                                            <GridTile>
                                                <div className="container centered vAlignCenter" >
                                                    <h2>{(this.props.cost) ? "$" + Math.round(this.props.cost) : ""}</h2>
                                                    {(this.props.cost > 0) && (
                                                        <p>Estimate</p>
                                                    )}
                                                    <FlatButton label="Explain" icon={<InfoOutline />}  labelPosition="after" onClick={this.handleOpenExplain} primary={true} />
                                                </div>
                                            </GridTile>
                                            
                                        
                                    )}

                                    {(this.state.provider.LogoURL !== null) && (
                                        
                                            
                                            <GridTile>
                                                {/*<div style={{margin:'0 auto', width:125, paddingTop:10}} >
                                                    <Avatar src={ this.state.provider.LogoURL } size={120}  />
                                                </div>*/}
                                                <img src={ this.state.provider.LogoURL } style={{ maxHeight: '100%', objectFit: 'contain' }} alt=""/>
                                            </GridTile>
                                        
                                    )}
                                    </GridList>


                                    <Divider />

                                    {(this.state.facilityRatings.length > 0) && (
                                        <div>
                                            <Card style={{boxShadow:'none'}}>
                                                    <CardHeader 
                                                        title={<h5>Facility Ratings</h5>}     
                                                        actAsExpander={true}
                                                        showExpandableButton={true} 
                                                    >
                                                    
                                                    </CardHeader>
                                                    <CardText expandable={true}>
                                                        <div style={{marginTop: '-25px'}} >
                                                            <table>
                                                                <tr>
                                                                    <td style={{width:140}}>
                                                                        <span className="truenoLight">OVERALL RATING</span>
                                                                            <HospitalRating rating={this.state.facilityRatings[0]} showText={false}/>
                                                                            {/*</span>*/}
                                                                        {/*<p className="truenoLight">OVERALL RATING</p>
                                                                        <HospitalRating rating={this.state.facilityRatings[0]} showText={false}/>*/}
                                                                    </td>
                                                                    <td style={{textAlign:'center', verticalAlign:'top'}}>
                                                                        <FlatButton label="More Ratings" 
                                                                            onClick={this.handleOpenRatings} 
                                                                            labelPosition="after" 
                                                                            primary={true}
                                                                            icon={<StarRating />}  
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </CardText> 
                                            </Card>
                                        </div>
                                    )}
                                </div>
                            )}

                            <Card style={{boxShadow:'none'}}>
                                <CardHeader 
                                    title={<h5>Address</h5>}     
                                    actAsExpander={true}
                                    showExpandableButton={true} 
                                >
                                
                                </CardHeader>
                                <CardText expandable={true}>
                                        {(this.state.provider.Addresses && this.state.provider.Addresses.map((address) =>
                                            <div key={ address.ProviderID  }>
                                                <div  style={{marginBottom:0, marginTop:-20, height:80}} >
                                                <FlatButton
                                                    label="Map"
                                                    labelPosition="after"
                                                    primary={true}
                                                    icon={<ActionDirections />} 
                                                    onClick={ () => this.getDirections(address) }
                                                    style={{float:'right'}}
                                                />
                                                    <span>{address.Address1 + " " + address.Address2 }</span><br />
                                                    <span>{ address.City + ", " + address.State + " " + address.ZipCode } </span>
                                                </div>
                                                <div style={{clear:'both'}} ></div>
                                            </div>
                                        ))}
                                </CardText>
                            </Card>
                        
                        </Paper>
                        
                        {(this.state.provider.AdditionalInfoSubject || this.state.provider.AdditionalInfoBody) && (
                            <div>
                                <br />
                                <Paper zDepth={1} style={{padding:15}}>
                                    <h4>{this.state.provider.AdditionalInfoSubject}</h4>
                                    <p>{this.state.provider.AdditionalInfoBody}</p>
                                </Paper>
                            </div>
                        )}
                    </div>
                )}
                    
                <Dialog actions={actions} open={this.state.openRatings} onRequestClose={this.handleClose} autoScrollBodyContent={true} >
                    <div>
                        {(this.state.facilityRatings.length > 0) && (
                            <div>
                                <h4>Facility Ratings</h4>
                                { dasFacilityRatings }
                            </div>
                        )}

                        {(this.state.complicationRatings.length > 0) && (
                            <div>
                                <h4>Complication Ratings</h4>
                                { dasComplicationsRatings }
                            </div>
                        )}
                    </div>
                </Dialog>

                <Dialog
                    actions={actions}
                    modal={false}
                    open={this.state.openExplain}
                    onRequestClose={this.handleClose} >
                    <p>{(this.props.cost > 0) ? 
                        "This is an estimated cost that includes both the doctor's fee and the hospital or clinic fee. Whether you pay the full cost of this estimate, or a partial amount, depends on what benefits phase you're in"
                        :
                        "Your total cost for this medical service at this provider may be the amount listed in this box. Your health plan has set this special rate directly at this high quality facility for your benefit. If you choose this option, your health plan may cover most, or all, of the cost of this medical service."}</p>
                </Dialog>
            </div>
        )
    }
}


const mapDispatchToProps = (dispatch) => {
  return {
    logDirectionsClick: (providerId, action) => {
      dispatch(logDirectionsClick(providerId, action));
    },
    logQualityClick: (providerId) => {
      dispatch(logQualityClick(providerId));
    },
    logDocDetailsClick: (providerId) => {
      dispatch(logDocDetailsClick(providerId));
    },
    logProviderView: (log) => {
        dispatch(logProviderView(log));
    }
  }
}

const mapStateToProps = (state) => ({
    results: state.thisApp.searchResults,
    member: state.thisApp.auth.member
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderCard)



// WEBPACK FOOTER //
// ./src/Components/ProviderCard.js